function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/use-axios";
var useData = function useData(_ref) {
  var _redux$isAuthenticate, _redux$auth;
  var userHash = _ref.userHash,
    otp = _ref.otp,
    setOtp = _ref.setOtp,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    isPoints = _ref.isPoints;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    deals = _useState2[0],
    setDeals = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showOtpModal = _useState4[0],
    setShowOtpModal = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    timeLeftToResend = _useState6[0],
    setTimeLeftToResend = _useState6[1];
  // const [userAccountSummary, setUserAccountSummary] = useState(null);

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    otpLoading = _useState8[0],
    setOtpLoading = _useState8[1];
  var isAuthenticated = (_redux$isAuthenticate = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated) !== null && _redux$isAuthenticate !== void 0 ? _redux$isAuthenticate : redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated;
  useAxios({});
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingDeal = _useAxios.isLoading,
    fetchDeals = _useAxios.sendRequest;

  // useEffect(() => {
  //     if (isAuthenticated) {
  //         getUserAccountSummary();
  //     }
  // }, [isAuthenticated]);

  //Get account summary data
  // const getUserAccountSummary = () => {
  //     winnreAuth({
  //         method: 'get',
  //         url: '/winnre/user/booking/account-summary'
  //     })
  //         .then((res) => {
  //             console.log('accoi', res);
  //             setUserAccountSummary(res);
  //         })
  //         .catch((e) => {
  //             setUserAccountSummary(null);
  //         });
  // };

  var getOtp = function getOtp() {
    var _window, _window2;
    setOtpLoading(true);
    setOtp("");
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("AddressFilled");
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("RewardsOTPRequsted");
    setShowOtpModal(true);
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "GET",
      url: "/winnre/user/deals/generate-otp?userHash=".concat(userHash)
    }).then(function (res) {
      setOtpLoading(false);
      console.log("Get OTP:", res);
      if ((res === null || res === void 0 ? void 0 : res.status) === "SUCCESS") {
        setTimeLeftToResend(59);
      } else {
        toast.error(res === null || res === void 0 ? void 0 : res.message);
      }
    })["catch"](function (err) {
      console.log(err);
      toast.error("Something went wrong. Please try again");
    });
  };
  var getOffers = function getOffers() {
    var _cartData;
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    var cartData = {
      cartValues: [],
      totalMrp: 0,
      totalProduct: 0,
      totalPoints: 0
    };
    if (oldCartData) {
      cartData = JSON.parse(oldCartData);
    }
    fetchDeals({
      isEncryptedResponse: isAuthenticated ? true : false,
      url: "/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&rewardsPage=true&cartValue=".concat((_cartData = cartData) === null || _cartData === void 0 ? void 0 : _cartData.totalPoints),
      method: "get",
      isFormData: true
    }, function (res) {
      console.log("ordersPage Deals", res === null || res === void 0 ? void 0 : res.content);
      setDeals(res === null || res === void 0 ? void 0 : res.content);
    });
  };
  return {
    deals: deals,
    loadingDeal: loadingDeal,
    showOtpModal: showOtpModal,
    setShowOtpModal: setShowOtpModal,
    getOtp: getOtp,
    timeLeftToResend: timeLeftToResend,
    // userAccountSummary,
    setTimeLeftToResend: setTimeLeftToResend,
    getOffers: getOffers,
    otpLoading: otpLoading
  };
};
export default useData;